import { render, staticRenderFns } from "./PublicTop.vue?vue&type=template&id=00ed1b88&scoped=true&"
import script from "./PublicTop.vue?vue&type=script&lang=js&"
export * from "./PublicTop.vue?vue&type=script&lang=js&"
import style0 from "./PublicTop.vue?vue&type=style&index=0&id=00ed1b88&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed1b88",
  null
  
)

export default component.exports